.downloadDialogPickers:nth-child(1) {
  margin-right: 1em;
}
